import { VisuallyHidden } from '@rbilabs/components-library/build/components/visually-hidden';
import styled from 'styled-components';

export const BooleanOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 55px;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: -0.5px;
  font-family: ${Styles.fontFamily.base};
`;

export const HiddenInput = styled(VisuallyHidden.withComponent('input'))`
  + label {
    color: ${Styles.color.black};
    flex: 1;
    border: 1px solid ${Styles.color.grey.five};
    display: flex;
    align-items: center;
    justify-content: center;
    outline: ${Styles.color.tertiary};
  }

  + label + label {
    border-left: none;
  }

  &[disabled] + label {
    color: ${Styles.color.grey.three};
    cursor: not-allowed;
  }

  &:checked + label {
    background: ${Styles.color.primary};
    color: ${Styles.color.white};
    border: none;
  }
`;
